import { render, staticRenderFns } from "./LabCategoryFilterSelect.vue?vue&type=template&id=548a631b&"
import script from "./LabCategoryFilterSelect.vue?vue&type=script&lang=js&"
export * from "./LabCategoryFilterSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports